import { Flex, Select, SelectProps, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";
import { useLanguageChooser } from "hooks/useLanguages";
import { selectNationalFlag } from "utils/flags";

const LanguageChooser = ({ className }: Pick<SelectProps, "className">) => {
  const { language, nationalFlag, handleLanguageChange, options } =
    useLanguageChooser();
  const [dropdownOpened, { toggle }] = useDisclosure();

  const renderOption: SelectProps["renderOption"] = ({
    option: { value, label },
  }) => {
    return (
      <Flex align={"center"} gap={4}>
        {selectNationalFlag(value)}
        <Text c={"black"} lh={1} fz={"sm"}>
          {label}
        </Text>
      </Flex>
    );
  };

  const rightSection = dropdownOpened ? (
    <IconChevronUp color="#010101" size={20} />
  ) : (
    <IconChevronDown color="#010101" size={20} />
  );

  const defaultClassNames = {
    dropdown: "bg-[#F8F9FA] border-[#E9ECEF]",
    input: "bg-[#F8F9FA] border-[#E9ECEF]",
  };

  return (
    <Select
      lh={1}
      fz={"sm"}
      fw={500}
      className={className}
      defaultValue={language}
      value={language}
      maxDropdownHeight={"calc(100vh - 220px)"}
      scrollAreaProps={{ type: "auto" }}
      dropdownOpened={dropdownOpened}
      onDropdownOpen={toggle}
      onDropdownClose={toggle}
      onChange={handleLanguageChange}
      classNames={defaultClassNames}
      withCheckIcon={false}
      data={options}
      renderOption={renderOption}
      rightSection={rightSection}
      rightSectionWidth={50}
      leftSectionWidth={50}
      leftSection={nationalFlag}
    />
  );
};

export default LanguageChooser;
